import apiClient from '@/config/api';
import axios from 'axios';
import config from '@/config/index.js';

const RESOURCE = '/carousel';
const LIST_URL = `${config.BASE_URL}/${RESOURCE.replace(/^\//, '')}`;

const cfg = () => ({
    headers: { 'Authorization': `Bearer ${sessionStorage.getItem('token')}` }
});

const multipartCfg = () => ({
    headers: {
        'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
        'Content-Type': 'multipart/form-data',
    }
});

export default {
    getCarousel({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get(LIST_URL, cfg())
                .then(res => {
                    commit('SET_ITEMS', res.data.data);
                    resolve(res.data.data);
                })
                .catch(err => reject(err));
        });
    },

    createCarousel({ commit }, formData) {
        return new Promise((resolve, reject) => {
            apiClient.post(RESOURCE, formData, multipartCfg())
                .then(res => {
                    commit('ADD_ITEM', res.data.data);
                    resolve(res.data);
                })
                .catch(err => reject(err));
        });
    },

    updateCarousel({ commit }, { id, formData }) {
        return new Promise((resolve, reject) => {
            apiClient.post(`${RESOURCE}/${id}?_method=PUT`, formData, multipartCfg())
                .then(res => {
                    commit('UPDATE_ITEM', res.data.data);
                    resolve(res.data);
                })
                .catch(err => reject(err));
        });
    },

    deleteCarousel({ commit }, id) {
        return new Promise((resolve, reject) => {
            apiClient.delete(`${RESOURCE}/${id}`, cfg())
                .then(res => {
                    commit('REMOVE_ITEM', id);
                    resolve(res.data);
                })
                .catch(err => reject(err));
        });
    },
}
